export enum EventTypeEnum {
    EOSP = 1,
    Arrived = 2,
    SOSP = 3,
    NorTender = 4,
    WellAnchored = 6,
    AnchorAweigh = 8,
    WellAnchoredCargoOps = 10,
    AnchorAweighCargoOps = 12,
    TankCleaningCommenced = 13,
    TankCleaningCompleted = 14,
    AllFast = 18,
    AllClear = 21,
    TransShipmentVesselAlongside = 30,
    TankInspectionCommenced = 32,
    TanksInspectionsResult = 34,
    PumpingCommence = 45,
    PumpingComplete = 46,
    PumpingStopped = 49,
    PumpingResumed = 50,
    TanksAcceptedEmpty = 55,
    BunkerBargeAlongside = 61,
    BunkerHoseOn = 79,
    BunkeringCompleted = 81,
    CargoHoseOn = 99,
    CargoHoseOff = 100,
    FreePratique = 120,
    CargoDelayStart = 131,
    CargoDelayStop = 132,
    BerthDelayWithProtestStart = 133,
    BerthDelayWithProtestStop = 134,
    SteamingForTankCleaningCommenced = 135,
    SteamingForTankCleaningCompleted = 136,
    DryDockingCommenced = 137,
    DryDockingCompleted = 138,
    PortQuestionnaire = 139,
    TankInspectionCompleted = 140,
    OperationalTargetConsumption = 141,
    OperationalTargetSpeed = 142,
    OperationalChangeToTargetConsumption = 143,
    OperationalChangeToTargetSpeed = 144,
    OperationalNonTargetVoyage = 145,
    OperationalChangeToNonTargetVoyage = 146,
    OperationalIdlCrossing = 147,
    OperationalAdjustHoursAfterTimeZoneChange = 148,
    OperationalStartTankPreparation = 149,
    OperationalStopTankPreparation = 150,
    OperationalStartAwaitingOrdersOrDrifting = 151,
    OperationalStopAwaitingOrdersOrDrifting = 152,
    NavigationalStartTrafficManeuvering = 153,
    NavigationalStopTrafficManeuvering = 154,
    NavigationalStartSafetyManeuvering = 155,
    NavigationalStopSafetyManeuvering = 156,
    NavigationalStartStormSheltering = 157,
    NavigationalStopStormSheltering = 158,
    NavigationalStartCasualtyAndSar = 159,
    NavigationalStopCasualtyAndSar = 160,
    NavigationalStartHighRiskArea = 161,
    NavigationalStopHighRiskArea = 162,
    NavigationalStartPilotManeuvering = 163,
    NavigationalStopPilotManeuvering = 164,
    NavigationalStartRiverPortManeuvering = 165,
    NavigationalStopRiverPortManeuvering = 166,
    TechnicalStartPropulsionSystemFailure = 167,
    TechnicalStopPropulsionSystemFailure = 168,
    TechnicalStartAuxiliarySystemFailure = 169,
    TechnicalStopAuxiliarySystemFailure = 170,
    TechnicalStartFuelQualityIssue = 171,
    TechnicalStopFuelQualityIssue = 172,
    TechnicalStartOtherTechnicalIssue = 173,
    TechnicalStopOtherTechnicalIssue = 174,
    NavigationalEnteringEcaZone = 175,
    NavigationalLeavingEcaZone = 176,
    ReTenderNor = 177,
    WellAnchoredNoCargo = 179,
    AnchorAweighNoCargo = 181,
    DryDockingBerthCommenced = 182,
    DryDockingBerthCompleted = 183,
    BunkerBargeAlongsideAtBerth = 184,
    BunkerBargeCastedOffAtBerth = 185,
    BunkerHoseOnAtBerth = 186,
    BunkeringCompletedAtBerth = 188,
    SimpleBerthArrival = 195,
    SimpleBerthDeparture = 196,
    SlopHoseOn = 198,
    SlopHoseOff = 199,
    PreWashCommenced = 200,
    PreWashCompleted = 201,
    DebunkerHoseOn = 202,
    DebunkeringCommenced = 203,
    DebunkeringCompleted = 204,
    DebunkerHoseOff = 205,
    NavigationalStartCasualtyAndSarDrill = 206,
    NavigationalStopCasualtyAndSarDrill = 207,
}
